import React, { useState } from "react";
import PropTypes from "prop-types";
import ValidatedSelect from "../../ClassesShared/ValidatedSelect";

function SkillsInput({ value = [], onChange, maxSkills = 50, maxLength = 50 }) {
  const [error, setError] = useState(null);

  const add = (text) => {
    const skill = String(text || "").trim();
    setError(null);
    if (!skill || value.some((existing) => existing.toLowerCase() === skill.toLowerCase())) return;
    if (skill.length > maxLength) {
      setError(`Keep each skill to ${maxLength} characters or fewer.`);
      return;
    }
    if (value.length >= maxSkills) {
      setError(`An instructor can have up to ${maxSkills} skills.`);
      return;
    }
    setError(null);
    onChange([...value, skill]);
  };

  return (
    <ValidatedSelect
      id="instructor-skills"
      label="Skills"
      error={error}
      announce
      multiple
      searchable
      createOnBlur
      placeholder="Add a skill"
      hint={error ? undefined : "Type and press Enter to add."}
      formatCreateLabel={(input) => `Add "${input}"`}
      noOptionsMessage="Type a skill to add it"
      options={value.map((skill) => ({ value: skill, label: skill }))}
      value={value}
      onChange={(next) => {
        setError(null);
        onChange(next || []);
      }}
      onCreateOption={add}
    />
  );
}

SkillsInput.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  maxSkills: PropTypes.number,
  maxLength: PropTypes.number,
};

export default SkillsInput;
